const setScrollPadding = () => {
    const header = document.querySelector('.stoof-navbar');
    if (typeof header !== 'undefined') {
        const headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--scroll-padding-height', headerHeight + 'px')

    }

}
export default setScrollPadding;